import ManageExtraActivity from 'common/activeElements/modals/ManageExtraActivity';
import ModalAbsence from 'common/activeElements/modals/ModalAbsence';
import ModalDeleteAbsence from 'common/activeElements/modals/ModalDeleteAbsence';
import ModalDeleteActivity from 'common/activeElements/modals/ModalDeleteActivity';
import ModalDeleteExtraActivity from 'common/activeElements/modals/ModalDeleteExtraActivity';
import ModalManualReconciliation from 'common/activeElements/modals/ModalManualReconciliation';
import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import ModalSetOnProtection from 'common/activeElements/modals/ModalSetOnProtection';
import ModalTravelToLocation from 'common/activeElements/modals/ModalTravelToLocation';
import { SIDEBAR_NAMES } from 'common/activeElements/sidebars/sidebarsNames';
import WorkAssignmentDetails from 'common/activeElements/sidebars/WorkAssignmentDetails';

import { crewTimelineStore } from './CrewTimelineStore';

export const PAGE_KEY = 'CrewTimeline';

export const makeActiveElementsConfig = (selectedTimezone) => {
	// Ensure we extract a string timezone value
	const timezoneValue =
		typeof selectedTimezone === 'string' ? selectedTimezone : selectedTimezone?.value || null;

	const refetchTimeline = () => {
		crewTimelineStore.fetchTimeline();
	};

	return [
		{
			name: MODAL_NAMES.absence,
			Component: (props) => (
				<ModalAbsence
					employeeId={props.initialData?.crewMemberId}
					baseTimezone={timezoneValue}
					onActionSuccess={refetchTimeline}
					{...props}
				/>
			),
		},
		{
			name: MODAL_NAMES.deleteAbsence,
			Component: (props) => <ModalDeleteAbsence onActionSuccess={refetchTimeline} {...props} />,
		},
		{
			name: MODAL_NAMES.traveling,
			Component: (props) => <ModalTravelToLocation baseTimezone={timezoneValue} {...props} />,
		},
		{
			name: MODAL_NAMES.protection,
			Component: (props) => <ModalSetOnProtection baseTimezone={timezoneValue} {...props} />,
		},
		{
			name: MODAL_NAMES.manualReconciliation,
			Component: (props) => (
				<ModalManualReconciliation
					baseTimezone={timezoneValue}
					onActionSuccess={refetchTimeline}
					{...props}
				/>
			),
		},
		{
			name: MODAL_NAMES.updateAuxiliaryWAStatus,
			Component: (props) => (
				<ModalDeleteActivity
					baseTimezone={timezoneValue}
					onActionSuccess={refetchTimeline}
					{...props}
				/>
			),
		},
		{
			name: MODAL_NAMES.manageExtraActivity,
			Component: (props) => (
				<ManageExtraActivity
					baseTimezone={timezoneValue}
					onActionSuccess={crewTimelineStore.mergeExtraActivitySequence}
					{...props}
				/>
			),
		},
		{
			name: MODAL_NAMES.deleteExtraActivity,
			Component: (props) => (
				<ModalDeleteExtraActivity
					isDeletingExtraActivity={() => crewTimelineStore.isDeletingExtraActivity}
					onDeleteExtraActivityAssignment={crewTimelineStore.rejectExtraActivityAssignment}
					{...props}
				/>
			),
		},

		{
			name: SIDEBAR_NAMES.waDetails,
			Component: (props) => <WorkAssignmentDetails {...props} />,
		},
	];
};
